import { render, staticRenderFns } from "./TotalsSalesPurchasesReport.vue?vue&type=template&id=557bdd13&scoped=true"
import script from "./TotalsSalesPurchasesReport.vue?vue&type=script&lang=js"
export * from "./TotalsSalesPurchasesReport.vue?vue&type=script&lang=js"
import style0 from "./TotalsSalesPurchasesReport.vue?vue&type=style&index=0&id=557bdd13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bdd13",
  null
  
)

export default component.exports